import MetricState from './MetricState';

/** Card shell for chart widgets with title/subtitle and shared state handling. */
export default function ChartCard({ testId, title, subtitle, status, error, onRetry, emptyText, minHeight = 240, actions, children }) {
  return (
    <section className="cb-card h-100" data-testid={testId} aria-label={title}>
      <header className="d-flex align-items-start justify-content-between mb-3">
        <div>
          <h3 className="cb-card__title mb-0">{title}</h3>
          {subtitle && <div className="small text-muted">{subtitle}</div>}
        </div>
        {actions}
      </header>
      <MetricState status={status} error={error} onRetry={onRetry} emptyText={emptyText} minHeight={minHeight}>
        {children}
      </MetricState>
    </section>
  );
}
